export const handleUpdateStatusSurveyInDetails = (state, { payload }) => {
  const target = state.activeAppointment;
  if (!target) return state;

  const handleReplaceItem = (allItem, item) => {
    if (item) {
      const index = allItem.findIndex(({ assignmentId }) => {
        return item.assignmentId === assignmentId;
      });
      allItem.splice(index, 1, item);
      return allItem;
    }
  };

  return {
    ...state,
    activeAppointment: {
      ...target,
      surveyAssignments: handleReplaceItem(target.surveyAssignments, payload),
    },
  };
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardTable/utils/handleUpdateStatusSurveyInDetails.js